import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  "data-test": "card-title",
  class: "card-title"
}
const _hoisted_2 = { class: "column label" }
const _hoisted_3 = { class: "row justify-left q-mt-md" }
const _hoisted_4 = { class: "datepicker-input" }
const _hoisted_5 = { class: "row items-center justify-end" }
const _hoisted_6 = { class: "row items-center justify-end" }
const _hoisted_7 = { class: "column label" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" * Information type ")
const _hoisted_9 = { class: "main-dropdown-100" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Status", -1 /* HOISTED */)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_12 = { class: "main-dropdown-100" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "red" }, "*"),
  /*#__PURE__*/_createTextVNode(" Event")
], -1 /* HOISTED */)
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = {
  class: "row",
  style: {"justify-content":"center"}
}
const _hoisted_17 = { key: 1 }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_19 = { key: 2 }
const _hoisted_20 = {
  key: 3,
  class: "column"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Shortfall", -1 /* HOISTED */)
const _hoisted_22 = { class: "row" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_24 = { class: "row analysis-data" }
const _hoisted_25 = { class: "label auto-size-kpi" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" Analysis type ")
const _hoisted_27 = { class: "label auto-size-kpi" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" Oil type ")
const _hoisted_29 = {
  key: 0,
  class: "label auto-size-kpi"
}
const _hoisted_30 = { class: "label auto-size-kpi status-selector" }
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" * Quality KPI ")
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { class: "col-4 q-pl-none q-pt-1" }
const _hoisted_34 = { class: "label auto-size-kpi" }
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" Analysis type ")
const _hoisted_36 = { class: "col-4 q-pt-1" }
const _hoisted_37 = { class: "label auto-size-kpi" }
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" Equipments ")
const _hoisted_39 = { class: "col-3 q-pt-1" }
const _hoisted_40 = { class: "label auto-size-kpi status-selector" }
const _hoisted_41 = /*#__PURE__*/_createTextVNode(" * Quality KPI ")
const _hoisted_42 = { class: "label column q-mb-md" }
const _hoisted_43 = {
  key: 1,
  class: "label column q-mb-md"
}
const _hoisted_44 = { class: "ellipsis relative-position" }
const _hoisted_45 = { class: "label column q-mb-md" }
const _hoisted_46 = /*#__PURE__*/_createTextVNode(" Add files ")
const _hoisted_47 = { class: "column q-mb-md" }
const _hoisted_48 = /*#__PURE__*/_createTextVNode(" WO number ")
const _hoisted_49 = { class: "column q-mb-md" }
const _hoisted_50 = /*#__PURE__*/_createTextVNode(" WO status ")
const _hoisted_51 = { class: "q-mb-md" }
const _hoisted_52 = { class: "label column q-mb-md" }
const _hoisted_53 = /*#__PURE__*/_createTextVNode(" Author ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_date = _resolveComponent("q-date")!
  const _component_q_popup_proxy = _resolveComponent("q-popup-proxy")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_time = _resolveComponent("q-time")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_EquipmentHierarchy = _resolveComponent("EquipmentHierarchy")!
  const _component_TradeHierarchy = _resolveComponent("TradeHierarchy")!
  const _component_q_toggle = _resolveComponent("q-toggle")!
  const _component_ElecAnalysis = _resolveComponent("ElecAnalysis")!
  const _component_q_chip = _resolveComponent("q-chip")!
  const _component_q_file = _resolveComponent("q-file")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.getDisplayEditCommentPopin,
      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.getDisplayEditCommentPopin) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, {
          class: "q-pa-md",
          style: {"width":"750px","overflow":"scroll","max-width":"100vw"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, { class: "row items-center q-pb-none" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.isReadOnly
                ? "Last " +
                  _ctx.getEquipmentCommentDetails?.informationType +
                  " comment"
                : "Please edit comment"), 1 /* TEXT */),
                _createVNode(_component_q_space),
                (!_ctx.hideCloseButton)
                  ? (_openBlock(), _createBlock(_component_q_btn, {
                      key: 0,
                      icon: "close",
                      flat: "",
                      round: "",
                      dense: "",
                      "data-test": "button-close",
                      onClick: _ctx.onClose
                    }, null, 8 /* PROPS */, ["onClick"]))
                  : _createCommentVNode("v-if", true)
              ]),
              _: 1 /* STABLE */
            }),
            (_ctx.commentLoaded)
              ? (_openBlock(), _createBlock(_component_q_card_section, { key: 0 }, {
                  default: _withCtx(() => [
                    _createElementVNode("form", {
                      class: "column",
                      onSubmit: _cache[26] || (_cache[26] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
                    }, [
                      _createElementVNode("span", _hoisted_2, [
                        _createTextVNode(_toDisplayString(_ctx.isReadOnly ? "Date" : "* Choose a date and time for the comment") + " ", 1 /* TEXT */),
                        _createElementVNode("div", _hoisted_3, [
                          _createElementVNode("div", _hoisted_4, [
                            _createVNode(_component_q_input, {
                              modelValue: _ctx.selectedDate,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedDate) = $event)),
                              disable: !_ctx.isDateEditable(),
                              readonly: _ctx.isReadOnly,
                              rules: [_ctx.isValidDate],
                              outlined: "",
                              dense: ""
                            }, {
                              prepend: _withCtx(() => [
                                _createVNode(_component_q_icon, {
                                  name: "event",
                                  class: _normalizeClass([_ctx.isReadOnly ? '' : 'cursor-pointer'])
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_popup_proxy, {
                                      "transition-show": "scale",
                                      "transition-hide": "scale"
                                    }, {
                                      default: _withCtx(() => [
                                        _withDirectives(_createVNode(_component_q_date, {
                                          modelValue: _ctx.selectedDate,
                                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedDate) = $event)),
                                          mask: "YYYY-MM-DD HH:mm",
                                          options: _ctx.minDate,
                                          bordered: ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("div", _hoisted_5, [
                                              _withDirectives(_createVNode(_component_q_btn, {
                                                label: "Close",
                                                color: "primary",
                                                flat: ""
                                              }, null, 512 /* NEED_PATCH */), [
                                                [_directive_close_popup]
                                              ])
                                            ])
                                          ]),
                                          _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["modelValue", "options"]), [
                                          [_vShow, !_ctx.isReadOnly]
                                        ])
                                      ]),
                                      _: 1 /* STABLE */
                                    })
                                  ]),
                                  _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["class"])
                              ]),
                              append: _withCtx(() => [
                                _createVNode(_component_q_icon, {
                                  name: "access_time",
                                  class: _normalizeClass([_ctx.isReadOnly ? '' : 'cursor-pointer'])
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_popup_proxy, {
                                      "transition-show": "scale",
                                      "transition-hide": "scale"
                                    }, {
                                      default: _withCtx(() => [
                                        _withDirectives(_createVNode(_component_q_time, {
                                          modelValue: _ctx.selectedDate,
                                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedDate) = $event)),
                                          mask: "YYYY-MM-DD HH:mm",
                                          options: _ctx.minTime,
                                          format24h: ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("div", _hoisted_6, [
                                              _withDirectives(_createVNode(_component_q_btn, {
                                                label: "Close",
                                                color: "primary",
                                                flat: ""
                                              }, null, 512 /* NEED_PATCH */), [
                                                [_directive_close_popup]
                                              ])
                                            ])
                                          ]),
                                          _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["modelValue", "options"]), [
                                          [_vShow, !_ctx.isReadOnly]
                                        ])
                                      ]),
                                      _: 1 /* STABLE */
                                    })
                                  ]),
                                  _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["class"])
                              ]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["modelValue", "disable", "readonly", "rules"])
                          ])
                        ])
                      ]),
                      _createElementVNode("span", _hoisted_7, [
                        _hoisted_8,
                        _createVNode(_component_q_select, {
                          modelValue: _ctx.selectedInformationType,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedInformationType) = $event)),
                          options: 
                  _ctx.getEquipmentDetails?.equipmentModel?.system !==
                  _ctx.equipmentSystemEnum.TRANSFORMERS
                    ? _ctx.informationTypesExtended
                    : _ctx.informationTypesExtendedTransformers
                ,
                          disable: _ctx.isReadOnly,
                          "option-label": "label",
                          "option-value": "value",
                          standout: "",
                          "map-options": "",
                          "emit-value": "",
                          "bottom-slots": "",
                          class: "q-mt-md main-dropdown-100",
                          borderless: "",
                          "input-style": {
                  fontFamily: 'Roboto',
                  fontSize: '12px',
                  lineHeight: '16px',
                },
                          "data-test": "information-type",
                          outlined: "",
                          dense: ""
                        }, null, 8 /* PROPS */, ["modelValue", "options", "disable"])
                      ]),
                      _withDirectives(_createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_9, [
                          _hoisted_10,
                          _createVNode(_component_q_select, {
                            modelValue: _ctx.selectedStatus,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedStatus) = $event)),
                            options: _ctx.equipmentStatus,
                            "option-label": "label",
                            "option-value": "value",
                            outlined: "",
                            "map-options": "",
                            "emit-value": "",
                            "data-test": "status-dropdown",
                            "transition-show": "scale",
                            "transition-hide": "scale",
                            dense: ""
                          }, null, 8 /* PROPS */, ["modelValue", "options"])
                        ]),
                        _hoisted_11,
                        _createElementVNode("div", _hoisted_12, [
                          _hoisted_13,
                          _createVNode(_component_q_select, {
                            modelValue: _ctx.selectedEvent,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedEvent) = $event)),
                            options: _ctx.availableEvents,
                            "option-label": "label",
                            "option-value": "value",
                            "map-options": "",
                            "emit-value": "",
                            "bottom-slots": "",
                            outlined: "",
                            "data-test": "event-dropdown",
                            rules: [(val) => !!val || 'Event is required'],
                            "lazy-rules": "",
                            dense: ""
                          }, null, 8 /* PROPS */, ["modelValue", "options", "rules"])
                        ]),
                        (_ctx.getEquipmentDetails.failureRootCause)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                              (_ctx.displaySpecificFailure())
                                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                    _createElementVNode("div", _hoisted_16, [
                                      _createVNode(_component_q_checkbox, {
                                        modelValue: _ctx.equipmentMajorFailure,
                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.equipmentMajorFailure) = $event)),
                                        "data-test": "equipment-major-failure",
                                        label: "Equipment major failure"
                                      }, null, 8 /* PROPS */, ["modelValue"]),
                                      _createVNode(_component_q_checkbox, {
                                        modelValue: _ctx.gasOrOilLeak,
                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.gasOrOilLeak) = $event)),
                                        "data-test": "gas-oil-leak",
                                        label: "Gas or oil leak"
                                      }, null, 8 /* PROPS */, ["modelValue"]),
                                      _createVNode(_component_q_checkbox, {
                                        modelValue: _ctx.fireConfirmed,
                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.fireConfirmed) = $event)),
                                        "data-test": "fire-confirmed",
                                        label: "Fire confirmed"
                                      }, null, 8 /* PROPS */, ["modelValue"])
                                    ])
                                  ]))
                                : _createCommentVNode("v-if", true),
                              (_ctx.eventDisplayEquipementList())
                                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                    _createVNode(_component_EquipmentHierarchy, {
                                      onEquipmentPath: _ctx.getEquipmentPath,
                                      onEquipmentName: _ctx.getSelectedEquipmentName
                                    }, null, 8 /* PROPS */, ["onEquipmentPath", "onEquipmentName"])
                                  ]))
                                : _createCommentVNode("v-if", true),
                              _hoisted_18,
                              _createVNode(_component_TradeHierarchy),
                              (_ctx.showSerialNumberSection())
                                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                    _createVNode(_component_q_toggle, {
                                      modelValue: _ctx.showSerialNumber,
                                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.showSerialNumber) = $event)),
                                      "checked-icon": "check",
                                      color: "green",
                                      label: `Serial number changed? Current is ${
                      _ctx.getLastSerialNumberFn.serialNumber
                        ? _ctx.getLastSerialNumberFn.serialNumber
                        : `Unknown`
                    }`,
                                      "unchecked-icon": "clear"
                                    }, null, 8 /* PROPS */, ["modelValue", "label"]),
                                    (_ctx.showSerialNumber)
                                      ? (_openBlock(), _createBlock(_component_q_input, {
                                          key: 0,
                                          modelValue: _ctx.serialNumber,
                                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.serialNumber) = $event)),
                                          label: "Serial Number",
                                          class: "q-mr-auto",
                                          "data-test": "serial-number",
                                          dense: ""
                                        }, null, 8 /* PROPS */, ["modelValue"]))
                                      : _createCommentVNode("v-if", true)
                                  ]))
                                : _createCommentVNode("v-if", true),
                              (_ctx.displayShortfall())
                                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                    _hoisted_21,
                                    _createElementVNode("div", _hoisted_22, [
                                      _createVNode(_component_q_input, {
                                        modelValue: _ctx.productionShortfall,
                                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.productionShortfall) = $event)),
                                        label: "Production Shortfall",
                                        "data-test": "production-shortfall",
                                        suffix: _ctx.getProductionShortfallUnit,
                                        class: "q-mr-auto",
                                        dense: ""
                                      }, null, 8 /* PROPS */, ["modelValue", "suffix"]),
                                      _createVNode(_component_q_input, {
                                        modelValue: _ctx.waterInjectShortfall,
                                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.waterInjectShortfall) = $event)),
                                        label: "Water Inject Shortfall",
                                        "data-test": "waterinject-shortfall",
                                        suffix: _ctx.getWaterInjectShortfallUnit,
                                        class: "q-ml-auto q-mr-auto",
                                        dense: ""
                                      }, null, 8 /* PROPS */, ["modelValue", "suffix"]),
                                      _createVNode(_component_q_input, {
                                        modelValue: _ctx.flaring,
                                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.flaring) = $event)),
                                        label: "Flaring",
                                        "data-test": "flaring-shortfall",
                                        suffix: _ctx.getFlaringUnit,
                                        class: "q-ml-auto",
                                        dense: ""
                                      }, null, 8 /* PROPS */, ["modelValue", "suffix"])
                                    ]),
                                    _hoisted_23
                                  ]))
                                : _createCommentVNode("v-if", true)
                            ]))
                          : _createCommentVNode("v-if", true)
                      ], 512 /* NEED_PATCH */), [
                        [_vShow, 
                _ctx.selectedInformationType === _ctx.informationTypeEnum.STATUS_CHANGE
              ]
                      ]),
                      _withDirectives(_createElementVNode("div", _hoisted_24, [
                        _createElementVNode("span", _hoisted_25, [
                          _hoisted_26,
                          _createVNode(_component_q_select, {
                            modelValue: _ctx.analysisType,
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.analysisType) = $event)),
                            options: _ctx.analysisTypes,
                            disable: _ctx.isReadOnly,
                            "option-label": "label",
                            "option-value": "value",
                            standout: "",
                            "map-options": "",
                            "emit-value": "",
                            "bottom-slots": "",
                            class: "q-mt-md q-pr-md main-dropdown-100",
                            borderless: "",
                            "input-style": {
                    fontFamily: 'Roboto',
                    fontSize: '12px',
                    lineHeight: '16px',
                  },
                            outlined: "",
                            dense: ""
                          }, null, 8 /* PROPS */, ["modelValue", "options", "disable"])
                        ]),
                        _withDirectives(_createElementVNode("span", _hoisted_27, [
                          _hoisted_28,
                          _createVNode(_component_q_select, {
                            modelValue: _ctx.oilType,
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.oilType) = $event)),
                            options: _ctx.oilTypes,
                            "option-label": "label",
                            "option-value": "value",
                            disable: _ctx.isReadOnly,
                            standout: "",
                            "map-options": "",
                            "emit-value": "",
                            "bottom-slots": "",
                            class: "q-mt-md q-pr-md main-dropdown-100",
                            borderless: "",
                            "input-style": {
                    fontFamily: 'Roboto',
                    fontSize: '12px',
                    lineHeight: '16px',
                  },
                            outlined: "",
                            dense: ""
                          }, null, 8 /* PROPS */, ["modelValue", "options", "disable"])
                        ], 512 /* NEED_PATCH */), [
                          [_vShow, 
                  _ctx.selectedInformationType === _ctx.informationTypeEnum.OIL &&
                  _ctx.getEquipmentDetails?.equipmentModel?.system !==
                    _ctx.equipmentSystemEnum.TRANSFORMERS
                ]
                        ]),
                        (
                  _ctx.getEquipmentDetails.driven === 'Compressor' ||
                  _ctx.getEquipmentDetails.driven === 'Pump'
                )
                          ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_29, [
                              _createTextVNode(_toDisplayString(_ctx.getDryGasSealLabel()) + " ", 1 /* TEXT */),
                              (_ctx.getDryGasSealLabel() === 'Dry gas seal type')
                                ? (_openBlock(), _createBlock(_component_q_select, {
                                    key: 0,
                                    modelValue: _ctx.dryGasSealType,
                                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.dryGasSealType) = $event)),
                                    options: _ctx.dryGasSealTypes,
                                    "option-label": "label",
                                    "option-value": "value",
                                    standout: "",
                                    "map-options": "",
                                    "emit-value": "",
                                    "bottom-slots": "",
                                    disable: _ctx.isReadOnly,
                                    class: "q-mt-md q-pr-md main-dropdown-100",
                                    "bg-color": "white",
                                    borderless: "",
                                    "input-style": {
                    fontFamily: 'Roboto',
                    fontSize: '12px',
                    lineHeight: '16px',
                  },
                                    outlined: "",
                                    dense: ""
                                  }, null, 8 /* PROPS */, ["modelValue", "options", "disable"]))
                                : _createCommentVNode("v-if", true),
                              (_ctx.getDryGasSealLabel() === 'Mechanical seal type')
                                ? (_openBlock(), _createBlock(_component_q_select, {
                                    key: 1,
                                    modelValue: _ctx.dryGasSealType,
                                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.dryGasSealType) = $event)),
                                    options: _ctx.dryGasSealTypesForDrivenPUMP,
                                    "option-label": "label",
                                    "option-value": "value",
                                    standout: "",
                                    "map-options": "",
                                    "emit-value": "",
                                    "bottom-slots": "",
                                    class: "q-mt-md q-pr-md main-dropdown-100",
                                    "bg-color": "white",
                                    borderless: "",
                                    "input-style": {
                    fontFamily: 'Roboto',
                    fontSize: '12px',
                    lineHeight: '16px',
                  },
                                    outlined: "",
                                    dense: ""
                                  }, null, 8 /* PROPS */, ["modelValue", "options"]))
                                : _createCommentVNode("v-if", true)
                            ], 512 /* NEED_PATCH */)), [
                              [_vShow, 
                  _ctx.selectedInformationType === _ctx.informationTypeEnum.DRY_GAS_SEAL
                ]
                            ])
                          : _createCommentVNode("v-if", true),
                        _createElementVNode("span", _hoisted_30, [
                          _hoisted_31,
                          _createVNode(_component_q_select, {
                            modelValue: _ctx.qualityKpi,
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.qualityKpi) = $event)),
                            options: _ctx.qualityKpis,
                            disable: _ctx.isReadOnly,
                            "option-label": "label",
                            "option-value": "value",
                            outlined: "",
                            standout: "",
                            "map-options": "",
                            "emit-value": "",
                            "bottom-slots": "",
                            class: _normalizeClass(_ctx.getClassQuality),
                            rules: [
                    (val) => val !== undefined || 'Please select Quality KPI',
                  ],
                            "lazy-rules": "",
                            dense: ""
                          }, {
                            prepend: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                class: _normalizeClass(_ctx.getClassQualityIcon),
                                name: _ctx.icon,
                                style: {"font-size":"14px"}
                              }, null, 8 /* PROPS */, ["class", "name"])
                            ]),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["modelValue", "options", "disable", "class", "rules"])
                        ]),
                        (
                  _ctx.getEquipmentDetails?.equipmentModel?.system ===
                    _ctx.equipmentSystemEnum.TRANSFORMERS &&
                  (_ctx.selectedInformationType === _ctx.informationTypeEnum.OIL ||
                    _ctx.selectedInformationType === _ctx.informationTypeEnum.INSULATION)
                )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                              _createVNode(_component_ElecAnalysis, {
                                "oil-analysis": _ctx.oilAnalysis,
                                "insulation-analysis": _ctx.insulationAnalysis,
                                "information-type": _ctx.selectedInformationType,
                                "is-read-only": _ctx.isReadOnly
                              }, null, 8 /* PROPS */, ["oil-analysis", "insulation-analysis", "information-type", "is-read-only"])
                            ]))
                          : _createCommentVNode("v-if", true)
                      ], 512 /* NEED_PATCH */), [
                        [_vShow, 
                _ctx.selectedInformationType !== _ctx.informationTypeEnum.OTHER &&
                _ctx.selectedInformationType !==
                  _ctx.informationTypeEnum.SERVICE_BULLETINS &&
                _ctx.selectedInformationType !== _ctx.informationTypeEnum.STATUS_CHANGE &&
                _ctx.selectedInformationType !== _ctx.informationTypeEnum.OFFSHORE &&
                _ctx.selectedInformationType !== _ctx.informationTypeEnum.VIBRATION
              ]
                      ]),
                      (_ctx.selectedInformationType === _ctx.informationTypeEnum.VIBRATION)
                        ? (_openBlock(), _createBlock(_component_q_card_section, { key: 0 }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vibrationRows, (row, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: index,
                                  class: "row q-col-gutter-md items-center q-mb-sm analysis-data"
                                }, [
                                  _createElementVNode("div", _hoisted_33, [
                                    _createElementVNode("span", _hoisted_34, [
                                      _hoisted_35,
                                      _createVNode(_component_q_select, {
                                        modelValue: row.analysisType,
                                        "onUpdate:modelValue": ($event: any) => ((row.analysisType) = $event),
                                        options: _ctx.analysisTypes,
                                        disable: _ctx.isReadOnly,
                                        "option-label": "label",
                                        "option-value": "value",
                                        standout: "",
                                        "map-options": "",
                                        "emit-value": "",
                                        "bottom-slots": "",
                                        class: "q-mt-md q-pr-md main-dropdown-100",
                                        borderless: "",
                                        "input-style": {
                        fontFamily: 'Roboto',
                        fontSize: '12px',
                        lineHeight: '16px',
                      },
                                        outlined: "",
                                        dense: ""
                                      }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "options", "disable"])
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_36, [
                                    _createElementVNode("span", _hoisted_37, [
                                      _hoisted_38,
                                      _createVNode(_component_q_select, {
                                        modelValue: row.equipmentType,
                                        "onUpdate:modelValue": ($event: any) => ((row.equipmentType) = $event),
                                        options: _ctx.equipmentTypes,
                                        disable: _ctx.isReadOnly,
                                        "option-label": "label",
                                        "option-value": "value",
                                        standout: "",
                                        "map-options": "",
                                        "emit-value": "",
                                        "bottom-slots": "",
                                        class: "q-mt-md q-pr-md main-dropdown-100",
                                        borderless: "",
                                        "input-style": {
                        fontFamily: 'Roboto',
                        fontSize: '12px',
                        lineHeight: '16px',
                      },
                                        outlined: "",
                                        dense: ""
                                      }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "options", "disable"])
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_39, [
                                    _createElementVNode("span", _hoisted_40, [
                                      _hoisted_41,
                                      _createVNode(_component_q_select, {
                                        modelValue: row.qualityKpi,
                                        "onUpdate:modelValue": ($event: any) => ((row.qualityKpi) = $event),
                                        options: _ctx.qualityKpis,
                                        disable: _ctx.isReadOnly,
                                        "option-label": "label",
                                        "option-value": "value",
                                        outlined: "",
                                        standout: "",
                                        "map-options": "",
                                        "emit-value": "",
                                        "bottom-slots": "",
                                        class: _normalizeClass(_ctx.getClassQuality),
                                        rules: [
                        (val) =>
                          val !== undefined || 'Please select Quality KPI',
                      ],
                                        "lazy-rules": "",
                                        dense: ""
                                      }, {
                                        prepend: _withCtx(() => [
                                          _createVNode(_component_q_icon, {
                                            class: _normalizeClass(_ctx.getClassQualityIcon),
                                            name: _ctx.icon,
                                            style: {"font-size":"14px"}
                                          }, null, 8 /* PROPS */, ["class", "name"])
                                        ]),
                                        _: 2 /* DYNAMIC */
                                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "onUpdate:modelValue", "options", "disable", "class", "rules"])
                                    ])
                                  ]),
                                  _createCommentVNode(" <div class=\"col-1 q-pt-1 flex justify-end\">\n                  <q-btn\n                    dense\n                    round\n                    icon=\"add\"\n                    color=\"primary\"\n                    @click=\"addRow\"\n                  />\n                </div> ")
                                ]))
                              }), 128 /* KEYED_FRAGMENT */))
                            ]),
                            _: 1 /* STABLE */
                          }))
                        : _createCommentVNode("v-if", true),
                      _createElementVNode("span", _hoisted_42, [
                        _createTextVNode(_toDisplayString(_ctx.getEquipmentDetails?.equipmentModel?.system !==
                _ctx.equipmentSystemEnum.TRANSFORMERS
                  ? "*"
                  : "") + " Event comment ", 1 /* TEXT */),
                        _createVNode(_component_q_input, {
                          modelValue: _ctx.commentLoaded.comment,
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.commentLoaded.comment) = $event)),
                          type: "textarea",
                          required: 
                  _ctx.getEquipmentDetails?.equipmentModel?.system !==
                  _ctx.equipmentSystemEnum.TRANSFORMERS
                ,
                          rows: "3",
                          readonly: _ctx.isReadOnly,
                          outlined: "",
                          dense: ""
                        }, null, 8 /* PROPS */, ["modelValue", "required", "readonly"])
                      ]),
                      (
                _ctx.getEquipmentCommentDetails.equipmentCommentFiles?.length > 0
              )
                        ? (_openBlock(), _createElementBlock("span", _hoisted_43, [
                            _createTextVNode(_toDisplayString(_ctx.isReadOnly ? "Files" : "Already uploaded files") + " ", 1 /* TEXT */),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getEquipmentCommentDetails.equipmentCommentFiles, (file) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: file.name
                              }, [
                                _createVNode(_component_q_chip, {
                                  color: "green",
                                  "text-color": "white",
                                  removable: !_ctx.isReadOnly,
                                  clickable: _ctx.isReadOnly,
                                  onClick: ($event: any) => (_ctx.downloadFile(file.name)),
                                  onRemove: ($event: any) => (_ctx.openConfirmDelete(file))
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_44, _toDisplayString(file.name), 1 /* TEXT */)
                                  ]),
                                  _: 2 /* DYNAMIC */
                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["removable", "clickable", "onClick", "onRemove"])
                              ]))
                            }), 128 /* KEYED_FRAGMENT */))
                          ]))
                        : _createCommentVNode("v-if", true),
                      _withDirectives(_createElementVNode("span", _hoisted_45, [
                        _hoisted_46,
                        _createVNode(_component_q_file, {
                          modelValue: _ctx.files,
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.files) = $event)),
                          label: "Select files",
                          multiple: "",
                          append: "",
                          "use-chips": "",
                          readonly: _ctx.isReadOnly,
                          outlined: "",
                          dense: "",
                          class: "file-upload"
                        }, {
                          prepend: _withCtx(() => [
                            _createVNode(_component_q_icon, { name: "cloud_upload" })
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["modelValue", "readonly"])
                      ], 512 /* NEED_PATCH */), [
                        [_vShow, !_ctx.isReadOnly]
                      ]),
                      _createElementVNode("label", _hoisted_47, [
                        _hoisted_48,
                        _createVNode(_component_q_input, {
                          modelValue: _ctx.commentLoaded.woNumber,
                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.commentLoaded.woNumber) = $event)),
                          maxlength: "10",
                          disabled: _ctx.isReadOnly,
                          outlined: "",
                          dense: "",
                          onKeypress: _cache[22] || (_cache[22] = ($event: any) => (_ctx.isNumberCheck($event)))
                        }, null, 8 /* PROPS */, ["modelValue", "disabled"])
                      ]),
                      _createElementVNode("label", _hoisted_49, [
                        _hoisted_50,
                        _createVNode(_component_q_input, {
                          modelValue: _ctx.commentLoaded.woStatus,
                          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.commentLoaded.woStatus) = $event)),
                          disabled: "",
                          outlined: "",
                          dense: ""
                        }, null, 8 /* PROPS */, ["modelValue"])
                      ]),
                      _createElementVNode("div", null, [
                        _createVNode(_component_q_checkbox, {
                          modelValue: _ctx.commentLoaded.addToWeeklyReport,
                          "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.commentLoaded.addToWeeklyReport) = $event)),
                          label: "Add to weekly report ?"
                        }, null, 8 /* PROPS */, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_51, [
                        _createVNode(_component_q_checkbox, {
                          modelValue: _ctx.commentLoaded.isAlert,
                          "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.commentLoaded.isAlert) = $event)),
                          label: "Display alert ?"
                        }, null, 8 /* PROPS */, ["modelValue"])
                      ]),
                      _createElementVNode("span", _hoisted_52, [
                        _hoisted_53,
                        _createElementVNode("div", null, _toDisplayString(_ctx.commentLoaded.author), 1 /* TEXT */)
                      ]),
                      _withDirectives(_createVNode(_component_q_card_actions, { align: "right" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_btn, {
                            outline: "",
                            rounded: "",
                            "no-caps": "",
                            class: "action-button",
                            type: "submit",
                            label: "Update comment"
                          })
                        ]),
                        _: 1 /* STABLE */
                      }, 512 /* NEED_PATCH */), [
                        [_vShow, !_ctx.isReadOnly]
                      ])
                    ], 32 /* HYDRATE_EVENTS */)
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true)
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue"]),
    _createVNode(_component_ConfirmDialog, {
      title: "Delete file",
      message: _ctx.confirmDeleteFileMessage,
      open: _ctx.displayConfirmDeleteDialog,
      onOnClose: _ctx.closeConfirmDelete,
      onOnConfirm: _ctx.onConfirmDelete
    }, null, 8 /* PROPS */, ["message", "open", "onOnClose", "onOnConfirm"])
  ]))
}